// @ts-ignore
import { Jodit, IJodit } from "jodit";
import { fileToFormData, postImage } from "services/images";

export const editorConfig: IJodit["options"] = {
  readonly: false,
  autofocus: true,
  tabIndex: 1,

  height: "300px",

  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  defaultActionOnPaste: "insert_clear_html",

  placeholder: "Write something awesome ...",
  beautyHTML: true,
  toolbarButtonSize: "large",
  buttons: [
    "source",
    "|",
    "bold",
    "italic",
    "|",
    "ul",
    "ol",
    "|",
    "font",
    "fontsize",
    "brush",
    "paragraph",
    "|",
    "video",
    "table",
    "link",
    "|",
    "left",
    "center",
    "right",
    "justify",
    "|",
    "undo",
    "redo",
    "|",
    "hr",
    "eraser",
    "fullsize",
    "preview",
  ],
  extraButtons: ["uploadImage"],
};

export const uploadImageButton = () => {
  Jodit.defaultOptions.controls.uploadImage = {
    name: "Upload image to Cloudinary",
    iconURL:
      "https://www.kindpng.com/picc/m/261-2619141_cage-clipart-victorian-cloud-upload-icon-svg-hd.png",
    exec: async (editor: any) => {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.click();

      input.onchange = async function () {
        const files = input.files;
        if (files) {
          const file = files[0];
          const formData = await fileToFormData(file);
          const image = await postImage(formData);

          const editorImage = editor.selection.j.createInside.element("img");
          editorImage.setAttribute("src", image.url);
          editor.selection.insertNode(editorImage);
        }
      };
    },
  };
};
